define('controller/dashboard.controller',['require','exports','module','underscore','fukit','view/dashboard.page','backbone.radio','model/disclosure.detail.model','fukit','model/usereact.flag.model','model/disclosure.model'],function(require, exports, module) {
  //prettier-ignore
  var _                     = require('underscore'),
      BaseController        = require('fukit').BaseController,
      DashboardPageView     = require('view/dashboard.page'),
      Radio                 = require('backbone.radio'),
      DisclosureDetailModel = require('model/disclosure.detail.model'),
      ROLES                 = require('fukit').Roles,
      UseReactFlagsModel    = require('model/usereact.flag.model'),
      DisclosureModel       = require('model/disclosure.model');

  if (!localStorage.getItem('productNewCoiUi')) {
    var coiModel;
    var productNewCoiUiValue = false;
    const enabledProductCollection = Radio.request('AppKit.resourceService', 'resource', 'enabledProductCollection');

    if (!_.isUndefined(enabledProductCollection)) {
      coiModel = enabledProductCollection.findWhere({ name: 'COI', active: true });
      const dataModel = coiModel.collection.models;
      const filteredDataArray = dataModel.filter(function(item) {
        return item.attributes.name === 'COI' && item.attributes.active === true;
      });
      productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
    }

    if (productNewCoiUiValue) {
      localStorage.setItem('productNewCoiUiValue', productNewCoiUiValue.toString());
      location.assign(location.origin + '/coi-react/dashboard');
    }
  }

  var DashboardController = BaseController.extend({
    radioRequests: {
      'controllers DashboardController': '@constructor',
    },

    resources: {
      newDisclosureModel: {
        model: DisclosureModel,
        attrs: {
          name: 'Disclosure',
        },
      },
      disclosuresNotAssignedToReviewerCollection: {
        collection: DisclosureDetailModel.Collection,
        fetchOnStart: true,
        filters: [
          {
            field: 'status',
            value: 'Under Pre-Review',
          },
        ],
        paginate: {
          size: 5,
        },
        sort: {
          field: 'submitDate',
          direction: 'ascending',
        },
      },

      // useReactFlagsModel: {
      //   model: UseReactFlagsModel,
      //   fetchOnStart: true,
      //   fetchWhenNew: true,
      // },

      disclosuresAssignedToMeCollection: {
        collection: DisclosureDetailModel.Collection,
        paginate: {
          size: 5,
        },
        sort: {
          field: 'reviewerAssignedDate',
          direction: 'ascending',
        },
      },
    },

    pageView: DashboardPageView,

    stateConfiguration: {
      defaults: {
        roles: ROLES.GLOBALACCESSROLES,
      },
    },

    onStart: function() {
      var userPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');
      var disclosuresAssignedToMeCollection = this.getResource('disclosuresAssignedToMeCollection');

      disclosuresAssignedToMeCollection.filters
        .addFilterWithField({ name: 'disclosureReviewerUserId' })
        .equals(userPrincipalModel.id);
      disclosuresAssignedToMeCollection.filters.addFilterWithField({ name: 'status' }).equals('Under Review');

      _.delay(function() {
        disclosuresAssignedToMeCollection
          .fetch()
          .promise()
          .bind(this)
          .catch(function(error) {
            console.error('An error occurred while fetching disclosures:', error);
          });
      }, 2000);
    },
  });
  module.exports = DashboardController;
});

